'use strict';
const $ = jQuery.noConflict();

$(function() {
	const stakingCards = {
		stickyTop: 170,
		breakpoint: 991,
		sectionHeight: 487,
		cardGap: 14,
		stackReveal: 26,

		init: function() {
			this.cacheDOM();
			if (!this.$blocks.length) return;
			this.bindEvents();
			this.setup();
		},

		cacheDOM: function() {
			this.$blocks = $('.js-staking-cards');
		},

		bindEvents: function() {
			$(window).on('resize', this.setup.bind(this));
			$(document).on('scroll', this.onScroll.bind(this));
		},

		setup: function() {
			this.isDesktop = window.innerWidth > this.breakpoint;

			this.$blocks.each((i, block) => {
				const $block = $(block);
				const $list = $block.find('.js-staking-cards-list');
				const $cards = $block.find('.js-staking-card');
				const count = $cards.length;

				$cards.css('transform', '');

				if (!this.isDesktop || count < 2) {
					$block.removeData('stakingConfig').css('--staking-scroll-height', '');
					$list.css('height', '');
					return;
				}

				let cardH = 0;
				$cards.each((j, card) => {
					if (card.offsetHeight > cardH) cardH = card.offsetHeight;
				});

				const gap = this.cardGap;
				const stackReveal = this.stackReveal;
				const stepDistance = this.sectionHeight;
				const scrollDistance = (count - 1) * stepDistance;

				$block.data('stakingConfig', {gap, stackReveal, cardH, stepDistance, scrollDistance});
				$block.css('--staking-scroll-height', `${scrollDistance}px`);
				$list.css('height', `${cardH}px`);
			});

			this.onScroll();
		},

		onScroll: function() {
			if (!this.isDesktop) return;

			this.$blocks.each((i, block) => {
				const config = $(block).data('stakingConfig');
				if (!config) return;

				const rect = block.getBoundingClientRect();
				const progress = Math.max(0, Math.min(this.stickyTop - rect.top, config.scrollDistance));
				const cards = block.querySelectorAll('.js-staking-card');

				cards.forEach((card, index) => {
					if (index === 0) return;

					const start = (index - 1) * config.stepDistance;
					const local = Math.max(0, Math.min(progress - start, config.stepDistance));
					const eased = local / config.stepDistance;
					const restOffset = index * config.stackReveal;
					const startOffset = index * (config.cardH + config.gap);
					const offset = restOffset + (1 - eased) * (startOffset - restOffset);

					card.style.transform = `translateY(${offset}px)`;
				});
			});
		},
	};

	stakingCards.init();
});
